const DEFAULT_LOCAL_API_URL = 'http://localhost:3082/api';

export const getApiBaseUrl = (): string => {
  const configured = (process.env.REACT_APP_API_URL || '').trim();
  if (configured && configured !== 'undefined') {
    return configured.replace(/\/$/, '');
  }
  return DEFAULT_LOCAL_API_URL;
};
